import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltInlineCommentsSectionFilterDropdownContentApplyButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-filter-dropdown-content-apply-button-wireframe", __assign({}, transformedProps), children));
};
export default VeltInlineCommentsSectionFilterDropdownContentApplyButtonWireframe;
